<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="1280px" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-row>
				<el-col :span="8">
					<el-form-item label="用户名:" label-width="150px" class="notBlank">
						<el-input v-model="addForm.logName" auto-complete="off" class="formItem200" size="small"
							maxLength="100" />
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="密码:" label-width="150px" class="notBlank">
						<el-input v-model="addForm.logPwd" auto-complete="off" class="formItem150" size="small"
							style="width: 100px;" maxLength="50" :disabled="addForm.isEditPwd == 0" />
						<span style="color:#606266;padding-left: 10px" v-if="addForm.id > 0"><el-checkbox
								v-model="addForm.isEditPwd" :true-label="1" :false-label="0"></el-checkbox> 修改</span>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="姓名:" label-width="150px" class="notBlank">
						<el-input v-model="addForm.realName" auto-complete="off" class="formItem200" size="small"
							maxLength="100" />
					</el-form-item>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="8">
					<el-form-item label="手机号:" label-width="150px" class="notBlank">
						<el-input v-model="addForm.mobileNo" auto-complete="off" class="formItem200" size="small"
							maxLength="50" />
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="会员类型:" label-width="150px" class="notBlank">
						<el-select v-model="addForm.userType" placeholder="请选择" size="small" class="formItem150">
							<el-option v-for="item in userTypeDict" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="会员过期时间:" label-width="150px" class="notBlank">
						<el-date-picker type="date" v-model="addForm.userEndTime" value-format="yyyy-MM-dd" size="small"
							class="formItem150"></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="用户分组:" label-width="150px" class="notBlank">
						<el-select v-model="addForm.groupId" placeholder="请选择" size="small" class="formItem">
							<el-option v-for="item in groupDict" :key="item.valuekey" :label="item.textkey"
								:value="item.valuekey">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="所属机构:" label-width="150px">
						<el-select v-model="addForm.schoolId" placeholder="请选择" size="small" class="formItem250"
							@change="changeSchool">
							<el-option v-for="item in schoolDict" :key="item.id" :label="item.schoolName"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="所属班级:" label-width="150px">
						<el-select v-model="addForm.classId" placeholder="请选择" size="small" class="formItem250" filterable>
							<el-option v-for="item in classDict" :key="item.id" :label="item.className+'('+item.gradeName+')'"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
					<el-col :span="8">
					<el-form-item label="带课老师:"  label-width="150px">
				   <el-select v-model="addForm.teacherId" placeholder="请选择" size="small" class="formItem250">
							<el-option v-for="item in teacherDict" :key="item.id" :label="item.teacherName"
								:value="item.id">
							</el-option>
						</el-select>
                </el-form-item>
				</el-col>
				<el-col :span="16"></el-col>
			</el-row>
		</el-form>
		<el-tabs type="border-card" v-model="currentTabType" v-if="addForm.id > 0" style="height: 500px;">
			<el-tab-pane label="交易统计" name="charge">
				<el-table :data="grid_data[0]" height="400px" border highlight-current-row
					@selection-change="(v) => { sels = v }" style="width: 100%;">
					<el-table-column prop="buyMonth" label="购买时长（月）" width="150"></el-table-column>
					<el-table-column prop="payMoney" label="支付金额" width="150"></el-table-column>
					<el-table-column prop="payTime" label="支付时间" width="150"
						:formatter="$util.dateFormatEx"></el-table-column>
					<el-table-column prop="payTransactionNo" label="支付流水号" width="200" show-overflow-tooltip></el-table-column>
					<el-table-column prop="memos" label="备注" width="200" show-overflow-tooltip></el-table-column>
				</el-table>

				<!--分页-->
				<pagination :totalPage="filters[0].total" :currentPage="filters[0].page" :pageSize="filters[0].rows"
					@pageSizeCallBack="(v) => { handleSizeChange(v, 0) }"
					@currentPageCallBack="(v) => { handleCurrentChange(v, 0) }"></pagination>
			</el-tab-pane>
			<el-tab-pane label="积分统计" name="score">
				<el-table :data="grid_data[1]" height="400px" border highlight-current-row
					@selection-change="(v) => { sels = v }" style="width: 100%;">
					<el-table-column prop="scoreNum" label="积分" width="80"></el-table-column>
					<!-- <el-table-column prop="scoreType" label="类型" width="150"></el-table-column> -->
					<el-table-column prop="addTime" label="时间" width="140"
						:formatter="$util.dateFormatEx"></el-table-column>
						<el-table-column prop="scoreReason" label="原因" width="250" show-overflow-tooltip></el-table-column>
				</el-table>
				<!--分页-->
				<pagination :totalPage="filters[1].total" :currentPage="filters[1].page" :pageSize="filters[1].rows"
					@pageSizeCallBack="(v) => { handleSizeChange(v, 1) }"
					@currentPageCallBack="(v) => { handleCurrentChange(v, 1) }"></pagination>
			</el-tab-pane>
			<el-tab-pane label="学习统计" name="study">
				<el-table :data="grid_data[2]" height="400px" border highlight-current-row
					@selection-change="(v) => { sels = v }" style="width: 100%;">
					<el-table-column prop="groupName" label="单元/知识点" width="150"></el-table-column>
					<el-table-column prop="totalNum" label="总题数" width="120"></el-table-column>
					<el-table-column prop="finishNum" label="完成数" width="100"></el-table-column>
					<el-table-column prop="lastStudyTime" label="最近学习时间"  min-width="140"	:formatter="$util.dateFormatEx"></el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="比赛统计" name="rank">
				<el-table :data="grid_data[3]" height="400px" border highlight-current-row
					@selection-change="(v) => { sels = v }" style="width: 100%;">
					<el-table-column prop="matchName" label="排位赛" width="150"></el-table-column>
					<el-table-column prop="joinCount" label="参与人数" width="100"></el-table-column>
					<el-table-column prop="proCount" label="总题数" width="120"></el-table-column>
					<el-table-column prop="totalAnswerTimes" label="答题时长(秒）" width="150"></el-table-column>
					<el-table-column prop="totalScore" label="总得分" width="150"></el-table-column>
					<el-table-column prop="rankCount" label="排名" width="100"></el-table-column>
					<el-table-column prop="addTime" label="开始做题时间" min-width="150" :formatter="$util.dateFormatEx"></el-table-column>
				</el-table>
			</el-tab-pane>

		</el-tabs>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
import pagination from '@/components/common/pagination.vue'
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	components: { pagination },
	data() {
		return {
			addForm: {
				id: 0,
				logName: '',
				logPwd: '',
				realName: '',
				mobileNo: '',
				sexType: '',
				headPicUrl: '',
				cityCode: '',
				cityName: '',
				personSign: '',
				scoreNum: 0,
				levelType: '',
				regTime: '',
				userType: '',
				userEndTime: '',
				offerUserId: 0,
				wxOpenId: '',
				wxNickName: '',
				status: 0,
				classId: '',
				schoolId: '',
				teacherId:'',
				isEditPwd: 0,
				groupId:0,
			},
			groupDict:[],
			schoolDict: [],
			classDict: [],
			teacherDict:[],
			currentTabType: 'charge',
			filters: [
				{
					userId: 0,
					payStatus: '',
					mobileNo:'',
					logName:'',
					payTime: '',
					payTime2: '',
					rows: 10,
					page: 1,
					total: 0
				},
				{
					userId: 0,
					scoreType: '',
					mobileNo:'',
					logName:'',
					addTime: '',
					addTime2: '',
					total: 0,
					rows: 10,
					page: 1
				}],
			grid_data: [[], [], [], []],
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		handleSizeChange(val, index) {
			this.filters[index].rows = val;
			if (index == 0) {
				this.getGridData0();
			}
			else if (index == 1) {
				this.getGridData1();
			}

		},
		handleCurrentChange(val) {
			this.filters[index].page = val;
			if (index == 0) {
				this.getGridData0();
			}
			else if (index == 1) {
				this.getGridData1();
			}
		},
		getGridData0() {
			this.filters[0].userId = this.addForm.id
			this.filters[0].payStatus = 1
			let formData = this.$util.jsonToForm(this.filters[0]);
			this.$axios.post("/school/getuserviprecordlist", formData).then(res => {
				this.filters[0].total = res.data.total;
				this.grid_data[0] = res.data.data;
			});
		},
		getGridData1() {
			this.filters[1].userId = this.addForm.id
			let formData = this.$util.jsonToForm(this.filters[1]);
			this.$axios.post("/school/getuserscorerecordlist", formData).then(res => {
				this.filters[1].total = res.data.total;
				this.grid_data[1] = res.data.data;
			});
		},
		getGridData2() {
			this.filters[1].userId = this.addForm.id
			let formData = this.$util.jsonToForm(this.filters[1]);
			this.$axios.post("/school/getUserStudyList", formData).then(res => {
				this.grid_data[2] = res.data.data;
			});
		},
		getGridData3() {
			this.filters[1].userId = this.addForm.id
			let formData = this.$util.jsonToForm(this.filters[1]);
			this.$axios.post("/school/getRankMatchList", formData).then(res => {
				this.grid_data[3] = res.data.data;
			});
		},
		async loadSchool() {
			let formData = this.$util.jsonToForm({
				schoolName: '',
				logName: '',
				linkTel: '',
				teamPerson: '',
				status: '',
				rows: 1000,
				page: 1
			});
			this.$axios.post("/school/getschoolinfolist", formData).then(res => {
				this.schoolDict = res.data.data;
				this.loadClass()
				this.loadTeacher()
			});
		},
		changeSchool(){
			this.addForm.teacherId=''
			this.addForm.teacherName=''
			this.addForm.classId=''
			this.loadClass()
			this.loadTeacher()
		},
		async loadClass() {
			this.classDict = []
			if (this.addForm.schoolId <= 0) {
				return
			}
			let formData = this.$util.jsonToForm({
				schoolId: this.addForm.schoolId,
				rows: 1000,
				page: 1
			});
			this.$axios.post("/school/getclassinfolist", formData).then(res => {
				this.classDict = res.data.data;
			});
			this.loadTeacher()
		},
		async loadTeacher() {

			this.teacherDict=[]
			if (this.addForm.schoolId <= 0) {
				return
			}
			let formData = this.$util.jsonToForm({
				teacherName: '',
				schoolId: this.addForm.schoolId,
				linkTel:'',
				rows: 1000,
				page: 1
			});
			this.$axios.post("/school/getteacherinfolist", formData).then(res => {
				this.teacherDict = res.data.data;
			});
		},
		initData() {
			this.$axios.get("/school/getuserinfoinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					if (this.addForm.id == 0) {
						this.addForm.classId = ''
						this.addForm.schoolId = ''
						this.addForm.teacherId=''
						this.addForm.levelType = ''
						this.addForm.userType = ''
						this.addForm.groupId=''
						this.$set(this.addForm, "isEditPwd", 1)
					}
					else {
						this.addForm.logPwd = ''
						this.$set(this.addForm, "isEditPwd", 0)
						if(this.addForm.teacherId==0) this.addForm.teacherId=''
						if(this.addForm.groupId==0) this.addForm.groupId=''
						this.loadClass()
						this.loadTeacher()
						this.getGridData0()
						this.getGridData1()
						this.getGridData2()
						this.getGridData3()
					}
				});
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			this.addForm.userEndTime = this.$util.dealDate(this.addForm.userEndTime)
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/school/userinfosave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.$emit("saveCallBack");
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	},
	async created() {
		await this.loadSchool()
		this.groupDict= (await this.getDictInfo('userGroup'))
	}
};
</script>

<style lang="less" scoped></style>
